import { useCallback, useEffect, useRef, useState } from 'react'

export function wolimyBezRuchu(): boolean {
  return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true
}

/**
 * Element, który znika natychmiast, wygląda jakby aplikacja się zacięła.
 * Ten hook daje mu czas na wyjście: `zamykanie` włącza klasę animacji,
 * a dopiero po niej wywołuje właściwe zamknięcie.
 *
 * Przy `prefers-reduced-motion` zamyka od razu — użytkownik prosił o brak ruchu,
 * a nie o dłuższe czekanie.
 */
export function useWyjscie(zamknij: () => void, czasMs = 180): {
  zamykanie: boolean
  rozpocznijZamykanie: () => void
} {
  const [zamykanie, ustawZamykanie] = useState(false)
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    return () => {
      if (timer.current !== null) clearTimeout(timer.current)
    }
  }, [])

  const rozpocznijZamykanie = useCallback(() => {
    if (wolimyBezRuchu()) {
      zamknij()
      return
    }
    // Drugie kliknięcie w trakcie wychodzenia nie może uruchomić kolejnego zegara.
    if (timer.current !== null) return
    ustawZamykanie(true)
    timer.current = setTimeout(() => {
      timer.current = null
      zamknij()
    }, czasMs)
  }, [zamknij, czasMs])

  return { zamykanie, rozpocznijZamykanie }
}

/**
 * Kierunek ostatniej zmiany okresu. Treść wjeżdża z tej strony, z której
 * „przyszła" — dzięki temu przewijanie miesięcy czyta się jak ruch po osi
 * czasu, a nie jak podmiana ekranu.
 */
export function useKierunek(): [number, (o: number) => void] {
  const [kierunek, ustawKierunek] = useState(0)
  return [kierunek, ustawKierunek]
}
